<template>
  <div class="hello bgWhite">
    <h1>欢迎访问国土规划院廉政小系统后台管理系统</h1>
  </div>
</template>
      <!-- 首页 -->

<script>
import bread from "@/components/Module/Bread";
import cesTable from '@/components/Module/Table';
import {mapState,mapActions } from 'vuex'
export default {
  data() {
    return {
      
    };
  },
  methods: {
    del(res){
      console.log(res)
    },
    update(res,i){
      console.log(res,i);
    }
  },
  computed:{
    ...mapState([
    'userObj'
  ])
  },
  mounted(){
    this.userObj;
  },
  components: {
    bread,
    cesTable
  }
};
</script>

<style scoped>
.hello {
  border: solid 1px #e6e6e6;
}
</style>
